export const approvalsInfo = {
	bengaluru: [
		{ code: "BBMP", name: "BBMP" },
		{ code: "BDA", name: "BDA" },
		{ code: "BMRDA", name: "BMRDA" },
		{ code: "CMC", name: "CMC" },
		{ code: "KIADB", name: "KIADB" },
		{ code: "panchayat", name: "Panchayath" },
		{ code: "biaapa", name: "BIAAPA" },
	],
};
